import React, { useState, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { Modal, ModalBody, Spinner } from "reactstrap";
import { postRoles, updateRoles, showRoles } from "../../../../MyApi/vendors";
import { toast } from "react-toastify";
import { getPermissions } from "../../../../MyApi/permissions";
import Select from "react-select"
const RolesModal = ({ show, onClose, refetch, mode, id }) => {
  const [name, setName] = useState("");
  const [addedPermissions ,setAddedPermissions]=useState("")
  const [targetUser,setTargetUser]=useState("admin")
  const {data}=useQuery(["permissions" ,targetUser],()=>getPermissions(targetUser))
 

  const { data: roleData, isLoading: roleLoading } = useQuery(
    ["role", id],
    () => showRoles(id),
    {
      enabled: mode === "edit" && !!id ,
    }
  );

  useEffect(() => {
    if (mode === "edit" && roleData?.data) {
      const roles = roleData.data;
      setName(roles.role.name || "");
      setAddedPermissions(roles.permissions || []);
      setTargetUser(roles.role.guard_name || "admin");
    } else if (mode === "add") {
      setName("");
      setAddedPermissions([]);
      setTargetUser("admin");
    }
  }, [mode, roleData, show]);
  const mutation = useMutation({
    mutationKey: mode === "edit" ? ["updateRoles", id] : ["postRoles"],
    mutationFn: (postData) => mode === "edit" ? updateRoles(postData, id) : postRoles(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      refetch();
      onClose("roles");
    },
    onError:(error)=>{
toast.error(`${error.response.data.message}`)
    }
  });
const rawPermissions= data?.data?.permissions ||[]
const permissions = [...new Set(rawPermissions)].map(p => ({
  label: p,
  value: p,
}));

const handleAddPermissions =(selectedOption)=>{
 const newPermissions= selectedOption ? selectedOption.map((option)=>(
  option.value
 )):""
setAddedPermissions(newPermissions)
}
const handleTargetPerson =(e)=>{
setTargetUser(e.target.value)
}
  const handlePost = () => {
const sendData = {
  name,
  permissions: addedPermissions,
  guard_name: targetUser,
  ...(mode === "edit" && { _method: "PUT" }),
};
   
    mutation.mutate(sendData);

  };
  const selectedPermissions = permissions.filter(p => addedPermissions.includes(p.value));

  return (
    <Modal isOpen={show} className="add">
      <ModalBody>
        <h5 className="fw-bold">{mode === "edit" ? "تعديل أدوار" : "إضافة أدوار"}</h5>

        <div className="row">
          <div className="col-12">
            <label htmlFor="" className="form-label"> الاسم</label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="col-12">
            <label htmlFor="" className="form-label">الصلاحيات</label>
           <Select name="permission" id="permission"  options={permissions} value={selectedPermissions} isMulti placeholder={"اضف الصلاحيات"} onChange={handleAddPermissions}>

           </Select>
          </div>
          <div className="col-12">
            <label  className="form-label">الشخص المستهدف</label>
            <select name="guard_name" id="guard_name" className="form-select" value={targetUser} onChange={handleTargetPerson}>
            <option value="admin">مدير</option>
            <option value="vendor">مالك</option>
            </select>

          </div>
        </div>
        <div className="d-flex gap-2 mt-3">
          <button className="btn btn-primary" onClick={handlePost} disabled={mutation.isLoading }>
            {mutation.isLoading ?<Spinner /> : "تأكيد"}{" "}
          </button>
          <button className="btn btn-white" onClick={() => onClose("roles")}>
            إلغاء
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default RolesModal;
